import { AppDialog } from "@/components/common";
import { Button } from "@/components/ui/button";
import { useTran } from "@/hooks";

const ConfirmDialog = ({
  open,
  onOpenChange,
  title,
  description,
  confirmLabel,
  cancelLabel,
  onConfirm,
  loading = false,
  tone = "default",
}) => {
  const { t } = useTran();
  const confirmVariant = tone === "danger" ? "destructive" : "default";

  return (
    <AppDialog
      open={open}
      onOpenChange={onOpenChange}
      title={title}
      description={description}
      size="sm"
      headerWrapperClassName="border-b-0 pb-0"
      footer={
        <>
          <Button
            variant="outline"
            onClick={() => onOpenChange?.(false)}
            disabled={loading}
          >
            {cancelLabel}
          </Button>
          <Button
            variant={confirmVariant}
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? t("Saving...") : confirmLabel}
          </Button>
        </>
      }
    />
  );
};

export default ConfirmDialog;
